export default __webpack_public_path__ + "static/media/Imperial Bronzesteel Slaughter Steed.4b9094d4.jpg";